import { useCallback, useEffect, useState } from "react";
import { Check } from "lucide-react";
import { adminApi } from "./adminApi";

export default function AdminBookings() {
  const [bookings, setBookings] = useState([]);
  const load = useCallback(async () => {
    const { data } = await adminApi.get("/admin/test/bookings");
    setBookings(data.bookings);
  }, []);
  useEffect(() => { load().catch(() => {}); }, [load]);

  const complete = async (bookingId, activity) => {
    if (!window.confirm(`Mark ${activity} as completed for this booking? This cannot be undone automatically.`)) return;
    const { data } = await adminApi.post(`/admin/test/bookings/${bookingId}/complete`, { activity });
    if (data.reward_unlocked) window.alert("Both activities complete — the cashback reward is now Eligible for Review.");
    await load();
  };

  return (
    <div data-testid="admin-bookings">
      {bookings.length === 0 ? <div className="admin-empty">No bookings yet.</div> : (
        <div className="table-scroll"><table className="leads-table" data-testid="bookings-table">
          <thead><tr><th>BOOKING</th><th>STUDENT</th><th>SCHEDULE</th><th>STATUS</th><th>CONSULTATION</th><th>VIVA</th></tr></thead>
          <tbody>{bookings.map((b) => <tr key={b.booking_id} data-testid={`bk-${b.booking_id}`}>
            <td><div className="lead-name">{b.booking_id}</div><div className="lead-sub">{b.difficulty || "—"}</div></td>
            <td>{b.student?.name}<div className="lead-sub">{b.student?.whatsapp}</div>{b.message && <div className="lead-sub">“{b.message}”</div>}</td>
            <td>{b.date}<div className="lead-sub">{b.slot} IST</div></td>
            <td><span className={b.status === "booked" ? "status-pill review" : "status-pill locked"}>{b.status.toUpperCase()}</span></td>
            <td>{b.consultation_done ? <span className="status-pill approved">DONE</span> : b.status === "booked" && <button className="admin-btn" onClick={() => complete(b.booking_id, "consultation")} data-testid={`bk-consult-${b.booking_id}`}><Check size={13} /> Mark done</button>}</td>
            <td>{b.viva_done ? <span className="status-pill approved">DONE</span> : b.status === "booked" && <button className="admin-btn" onClick={() => complete(b.booking_id, "viva")} data-testid={`bk-viva-${b.booking_id}`}><Check size={13} /> Mark done</button>}</td>
          </tr>)}</tbody>
        </table></div>
      )}
    </div>
  );
}
